import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TeamService } from './team.service';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
  animations: [
    trigger('panelState', [
      state('closed', style({ height:'0px', visibility: 'hidden', display: 'none' })),
      state('open', style({ height:'*', visibility: 'visible', display: 'block' })),
      transition('closed <=> open', animate('300ms ease-in-out')),
    ]),
    trigger('toggleState', [
      state('collapsed', style({
        background: 'url("/assets/svg/plus-w.svg") no-repeat center center',
        backgroundSize: '30px',
        backgroundColor: '#7c02af',
        width: '2.5vw',
        height: '2.5vw',
      })),
      state('expanded', style({
        background: 'url("/assets/svg/arrow-down-w.svg") no-repeat center center',
        backgroundSize: '30px',
        backgroundColor: '#7c02af',
        width: '2.5vw',
        height: '2.5vw'

      })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
    ]),
  ],
})
export class TeamComponent implements OnInit {
  folded = "closed";
  collapse = "collapsed"

  public team;

  constructor(private teamService: TeamService) { }

  ngOnInit() {
    this.getTeam();
    console.log(this.collapse, this.folded)
  }

  getTeam() {
    this.teamService.getTeam().subscribe(
      data => { this.team = data },
      err => console.error(err),
      () => console.log(this.team)
    );

  }


  toggleFold(){
    this.folded = this.folded === 'open' ? 'closed' : 'open';
    this.collapse = this.collapse === 'expanded' ? 'collapsed' : 'expanded';
    console.log(this.collapse, this.folded)
  }
}



// WEBPACK FOOTER //
// ./src/app/team/team.component.ts